import React from 'react';

import { ProtocolIcon, MarketName } from 'components';
import { FontSize, getFontSizeCSS, styled } from 'core/styles';
import { ProductSlug, NetworkSlug } from 'domain/types';

type PositionNameProps = {
  productSlug: ProductSlug;
  productName: string;
  network: NetworkSlug;
  marketName: string;
  maxWidth?: number;
  fontSize?: FontSize;
};

export function PositionName(props: PositionNameProps) {
  const { productSlug, productName, network, marketName, maxWidth, fontSize = 'small' } = props;

  return (
    <NameBox fontSize={fontSize}>
      <ProtocolIcon
        productSlug={productSlug}
        network={network}
        tooltip={productName}
        fontSize="inherit"
      />
      <MarketName
        marketName={marketName}
        maxWidth={maxWidth}
        tooltipProps={{ placement: 'right', disableInteractive: true }}
      />
    </NameBox>
  );
}

const NameBox = styled('div', { shouldForwardProp: prop => prop !== 'fontSize' })<{
  fontSize: FontSize;
}>(({ fontSize }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: getFontSizeCSS({ fontSize }),
}));
